import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultParagraphMediumFactory,
  DefaultParagraphSmallFactory,
  DefaultTitleLargeFactory,
  DefaultTitleSmallFactory,
} from "components/common/Typograph/Typograph.Style";

export const SectionBoardsAndCommitteesContainer = styled.section(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "40px",

    paddingTop: "40px",
    paddingBottom: "40px",

    [theme.breakpoint.xl()]: {
      paddingBottom: "60px",
      paddingTop: "60px",
    },
  })
);

export const SectionBoardsAndCommitteesHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const SectionBoardsAndCommitteesTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
  fontWeight: "700",
  color: theme.color.neutral["02"],
  margin: 0,
}));

export const SectionBoardsAndCommitteesDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  margin: 0,
}));

export const SectionBoardsAndCommitteesContent = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "32px",
}));

export const SectionBoardsAndCommitteesControls = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  flex: 1,
}));

export const SectionBoardsAndCommitteesControlItem = styled.div(
  ({ theme, $isActive }) => ({
    width: "fit-content",
    borderLeft: `2px solid ${theme.color.line.medium}`,
    opacity: $isActive ? "1" : ".4",
    paddingLeft: "16px",
    cursor: "pointer",
  })
);

export const SectionBoardsAndCommitteesControlItemTitle = styled.h3(
  ({ theme }) => ({
    ...DefaultTitleSmallFactory({ theme }),
    color: theme.color.brandPrimary.light,
    fontWeight: "700",
    margin: 0,
  })
);

export const SectionBoardsAndCommitteesControlItemSubtitle = styled.p(
  ({ theme }) => ({
    ...DefaultParagraphSmallFactory({ theme }),
    color: theme.color.brandPrimary.light,
    fontWeight: "500",
    margin: 0,
  })
);

export const SectionBoardsAndCommitteesControlsImage = styled.div(() => ({
  flex: 1,
  display: "grid",
  alignItems: "center",
  justifyContent: "end",

  img: {
    marginLeft: "auto",
  },
}));

export const SectionBoardsAndCommitteesCard = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",

  img: {
    maxWidth: "100%",
    width: "100%",
  },
}));

export const SectionBoardsAndCommitteesCardHeader = styled.div(() => ({}));

export const SectionBoardsAndCommitteesCardTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  fontWeight: "700",
  color: theme.color.brandPrimary.light,
  padding: 0,
  margin: 0,
}));

export const SectionBoardsAndCommitteesCardSubtitle = styled.p(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
  color: theme.color.brandPrimary.light,
  padding: 0,
  margin: 0,
}));

export const SectionBoardsAndCommitteesCardImage = styled.div(() => ({
  img: {
    maxHeight: "187px",
    objectFit: "initial",
  },
}));
